export default {
  title: 'Lignes de production',
  description: 'Gestion des lignes de production industrielles',
  noResults: 'Aucune ligne de production trouvée',
  viewDetails: 'Voir détails',
  incidents: 'incident(s)',
  actions: 'action(s)',
  stats: {
    total: 'Total Lignes',
    running: 'En cours',
    avgOee: 'TRS Moyen',
    producedToday: 'Produit aujourd\'hui'
  },
  filters: {
    status: 'Statut',
    type: 'Type'
  },
  status: {
    running: 'En cours',
    stopped: 'Arrêtée',
    maintenance: 'Maintenance',
    error: 'Erreur'
  },
  type: {
    assembly: 'Assemblage',
    machining: 'Usinage',
    packaging: 'Conditionnement',
    preparation: 'Préparation',
    quality_control: 'Contrôle Qualité'
  },
  metrics: {
    speed: 'Vitesse',
    quality: 'Qualité',
    produced: 'Produit',
    defects: 'Défauts'
  }
}
